export default __webpack_public_path__ + "static/media/seafood.f92758ee.png";